/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import { getUrlSync, IActionContext } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

/**
 * Syncronously creates a product url.
 * @param product Simple product to get url from.
 * @param ctx
 * @param category Category to add to product url.
 */
export function getProductUrlSync(product: SimpleProduct, ctx: IActionContext, category?: CategoryHierarchy): string {
    const selectedProduct = { ...product, RecordId: product.MasterProductId || product.RecordId };

    return getProductPageUrlSync(selectedProduct.Name || '', selectedProduct.RecordId, ctx, category)!;
}

/**
 * Syncronously creates a product detail page url.
 * @param name Simple product name.
 * @param recordId Record id of product.
 * @param ctx
 * @param category
 */
export function getProductPageUrlSync(name: string, recordId: number, ctx: IActionContext, category?: CategoryHierarchy): string {
    return getUrlSync('product', ctx, {
        product: { Name: name || '', RecordId: recordId },
        category
    })!;
}
